import React, { useState } from 'react';

import ContentItem from '../ContentItem';
import DetailsPaymentAccount from '../DetailsPaymentAccount';

const RenderContentPaymentAccount = ({
    paymentAccounts,
    orderDetails,
    message,
}) => {
    const [detailsItem, setDetailsItem] = useState(null);
    const rows = Array.isArray(paymentAccounts) ? paymentAccounts : [];

    return (
        <div className="renderContentPaymentAccount">
            <div className="renderContentPaymentAccount__items">
                {rows.length > 0 ? rows.map((item, index) => {
                    const receipts = Array.isArray(item?.itemPictures) ? item.itemPictures : [];

                    return (
                        <div
                            className="renderContentPaymentAccount__row"
                            key={item?._id || index}
                        >
                            <ContentItem
                                orderDetails={orderDetails}
                                index={index}
                                item={item}
                            />

                            <button
                                type="button"
                                className="renderContentPaymentAccount__detailsButton"
                                onClick={() => setDetailsItem(item)}
                            >
                                Подробности{receipts.length ? ` · чеки ${receipts.length}` : ''}
                            </button>
                        </div>
                    );
                }) : (
                    <div className="renderContentPaymentAccount__textEmpty">
                        {message}
                    </div>
                )}
            </div>

            <DetailsPaymentAccount
                item={detailsItem}
                show={!!detailsItem}
                setShowDetails={(nextShow) => {
                    if (!nextShow) setDetailsItem(null);
                }}
            />
        </div>
    );
};

export default RenderContentPaymentAccount;
